var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubUsersIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.438C7.176 2.438 2.437 7.176 2.437 13c0 5.824 4.739 10.563 10.563 10.563 5.824 0 10.563-4.739 10.563-10.563 0-5.824-4.739-10.563-10.563-10.563zM10.45 8.37c.643-.682 1.549-1.057 2.55-1.057s1.899.377 2.545 1.063c.654.695.973 1.628.897 2.631-.15 1.993-1.694 3.618-3.442 3.618-1.748 0-3.295-1.625-3.442-3.618-.075-1.012.243-1.948.892-2.637zM13 21.938a8.91 8.91 0 01-6.398-2.703 6.243 6.243 0 011.784-1.698c1.294-.83 2.933-1.287 4.614-1.287s3.32.457 4.613 1.287a6.24 6.24 0 011.785 1.698A8.908 8.908 0 0113 21.938z",
    fill: "#373737"
  })));
}
export default SvgSubUsersIc;